import React from 'react';
import bemComponent from '@99designs/utils/app/bemComponent';

export class Main extends React.Component {
    render() {
        return (
            <div className="fullscreen-sidebar">
                <div className="fullscreen-sidebar__inner">{this.props.children}</div>
            </div>
        );
    }
}

export const Header = bemComponent('fullscreen-sidebar__header', 'Header');
export const Footer = bemComponent('fullscreen-sidebar__footer', 'Footer');

export class Body extends React.Component {
    render() {
        return (
            <div className="fullscreen-sidebar__body">
                <div className="fullscreen-sidebar__body__inner" id="fullscreenSidebar">
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/fullscreen/components/Sidebar.js